<template>
    <div class="c-about-transform">
        <y-row>
            <y-col
                lg="12"
                md="12"
            >
                <div class="c-about-transform__title">
                    <h2>
                        {{ fields.field3 }}
                    </h2>
                </div>
            </y-col>
            <y-col
                lg="12"
                md="12"
                class="c-about-transform__content"
            >
                <p>
                    {{ fields.field4 }}
                </p>
            </y-col>
            <y-col
                v-for="(item, index) in content.albums"
                :key="`c-about-transform-${index}`"
                lg="6"
                md="12"
                class="c-about-transform__img-box"
            >
                <img
                    :src="item.link"
                    :alt="item.title"
                >
            </y-col>
        </y-row>
    </div>
</template>

<script>

    export default {
        name: 'TransformingBusinesses',

        props: {
            content: Object,
            fields : Object,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
